import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './GlobalNavbar.css';
import logoImage from '../Assets/images/logo.png';

const GlobalNavbar = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <>
      <header className="global-navbar-container">
        <nav className="global-navbar-content">
          <Link to="/" className="global-navbar-logo-link">
            <img src={logoImage} alt="MTPRO" className="global-logo-img" />
          </Link>

          <button
            className={`global-burger ${isMenuOpen ? 'open' : ''}`}
            type="button"
            aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
            onClick={toggleMenu}
          >
            <span className="global-burger-line" />
            <span className="global-burger-line" />
            <span className="global-burger-line" />
          </button>

          <ul className="global-nav-links">
            <li className={location.pathname === '/' ? 'active' : ''}>
              <Link to="/">Home</Link>
            </li>
            <li className={location.pathname === '/about' ? 'active' : ''}>
              <Link to="/about">About</Link>
            </li>
            <li className={location.pathname === '/services' ? 'active' : ''}>
              <Link to="/services">Services</Link>
            </li>
            <li className={location.pathname === '/contact' ? 'active' : ''}>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>

          <div className="global-nav-actions">
            <span className="global-contact-number">
              Call Us: <span className="highlight">+20 1015955664</span>
            </span>
            <Link to="/contact" className="global-btn-get-touch">
              Get In Touch
            </Link>
          </div>
        </nav>
      </header>

      {isMenuOpen && (
        <div className="global-mobile-overlay" onClick={closeMenu}>
          <div
            className="global-mobile-drawer"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="global-mobile-close"
              type="button"
              aria-label="Close navigation menu"
              onClick={closeMenu}
            >
              ×
            </button>

            <ul className="global-mobile-nav-links">
              <li
                className={location.pathname === '/' ? 'active' : ''}
                onClick={closeMenu}
              >
                <Link to="/">Home</Link>
              </li>
              <li
                className={location.pathname === '/about' ? 'active' : ''}
                onClick={closeMenu}
              >
                <Link to="/about">About</Link>
              </li>
              <li
                className={location.pathname === '/services' ? 'active' : ''}
                onClick={closeMenu}
              >
                <Link to="/services">Services</Link>
              </li>
              <li
                className={location.pathname === '/contact' ? 'active' : ''}
                onClick={closeMenu}
              >
                <Link to="/contact">Contact</Link>
              </li>
            </ul>

            <div className="global-mobile-actions">
              <span className="global-contact-number">
                Call Us: <span className="highlight">+20 1015955664</span>
              </span>
              <Link
                to="/contact"
                className="global-btn-get-touch"
                onClick={closeMenu}
              >
                Get In Touch
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GlobalNavbar;
